import React from "react";
import { useTranslation } from "react-i18next";

import LottieAnimation from "./LottieAnimation";
import { Container, Button, AnimatedText } from "./styled";
import { Border } from "../styled";
import { analytics } from "../../../../../../analytics";
import { useCardsStore } from "../../../../../../stores/use-cards-store";

const Landing = () => {
  const { t } = useTranslation();

  const { setIsPromptLoading } = useCardsStore((state) => ({
    setIsPromptLoading: state.setIsPromptLoading,
  }));

  return (
    <Container className="intelligence-loading">
      <LottieAnimation />
      <AnimatedText>{t("cards-ai.crafting")}</AnimatedText>

      <Border isActive style={{ marginTop: "20px", fontSize: "14px" }}>
        <Button
          onClick={() => {
            setIsPromptLoading(false);
            analytics.logEvent({ name: "Cards AI canceled" });
          }}
        >
          <AnimatedText>{t("cards-ai.cancel")}</AnimatedText>
        </Button>
      </Border>
    </Container>
  );
};

export default Landing;
